import React, { Component } from "react";
import { fetchPrivacyPolicy } from "../../domains/PrivacyDomain";

class PrivacyPolicyPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      policy: null,
      loading: true,
      error: null,
    };
  }

  componentDidMount = async () => {
    try {
      const policy = await fetchPrivacyPolicy(this.props.route.coachOrgId);
      this.setState({ policy, loading: false });
    } catch (error) {
      this.setState({ error: "Failed to load privacy policy", loading: false });
    }
  };

  formatEmail(email) {
    return (
      <a href={`mailto:${email}`} target="_blank" rel="noopener noreferrer">
        {email}
      </a>
    );
  }

  renderSection(section, index) {
    return (
      <section key={index} className="privacy-section">
        <h2 className="section-title">{section.title}</h2>
        {section.subsections ? (
          section.subsections.map((sub, subIndex) => (
            <div key={subIndex} className="subsection">
              <h3 className="subsection-title">{sub.title}</h3>
              <ul className="content-list">
                {sub.content.map((item, itemIndex) => (
                  <li key={itemIndex} className="content-item">
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))
        ) : (
          <ul className="content-list">
            {section.content.map((item, itemIndex) => (
              <li key={itemIndex} className="content-item">
                {item.includes("@") ? this.formatEmail(item) : item}
              </li>
            ))}
          </ul>
        )}
      </section>
    );
  }

  render() {
    const { policy, loading, error } = this.state;

    if (loading) {
      return null;
    }

    if (error) {
      return <div className="error-message">{error}</div>;
    }

    if (!policy) {
      return (
        <div className="error-message">
          Privacy policy failed to load. Please contact{" "}
          {this.formatEmail("privacy@trybe.do")}
        </div>
      );
    }

    const { title, lastUpdated, welcomeMessage, sections } = policy;

    return (
      <div className="privacy-policy">
        <header className="privacy-header">
          <h1 className="privacy-title">{title || "Privacy Policy"}</h1>
          <p className="privacy-metadata">Last Updated: {lastUpdated || "N/A"}</p>
          {welcomeMessage && <p className="privacy-welcome">{welcomeMessage}</p>}
        </header>
        {sections && sections.length > 0 ? (
          sections.map((section, index) => this.renderSection(section, index))
        ) : (
          <div>No sections available.</div>
        )}
      </div>
    );
  }
}

export default PrivacyPolicyPage;



// WEBPACK FOOTER //
// ./src/components/privacy/PrivacyPolicy.js